import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@/components/atoms/Button/Button';
import EmphasisedText from '@/components/atoms/EmphasisedText/EmphasisedText';
import SectionWrapper from '@/components/atoms/SectionWrapper/SectionWrapper';
import Carousel from '@/components/molecules/Carousel/Carousel';
import FeatureBrandCard from '@/components/molecules/FeatureBrandCard/FeatureBrandCard';
import { dataLayerPush } from '@/helpers/dataLayer';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import clsx from 'clsx';
import { EffectCoverflow } from 'swiper/modules';
const FeaturedStores = ({ title, subtitle, items, viewLabel, link, nextIcon, nextLabel, previousIcon, previousLabel, slideProgressLabel, centreTheme, theme, topPadding, bottomPadding, anchorNavTitle, }) => {
    const breakpoint = useBreakpoint();
    let minimumSlides = 16;
    if (breakpoint === 'base' || breakpoint === 'sm') {
        minimumSlides = 4;
    }
    return (_jsxs(SectionWrapper, { className: "grid gap-2 bg-surface-primary lg:gap-2.5 dark:bg-surface-expressive", centreTheme: centreTheme, theme: theme, topPadding: topPadding, bottomPadding: bottomPadding, anchorNavTitle: anchorNavTitle, "data-testid": "FeaturedStores-organism", enableAnimations: true, children: [_jsxs("div", { className: clsx(subtitle ? 'max-w-[1036px]' : 'max-w-[824px]', 'mx-auto flex flex-col items-center gap-1.5'), "data-testid": "featured-stores-heading", children: [_jsx("h2", { className: clsx(subtitle ? 'type-heading-2xl' : 'type-heading-3xl', 'text-center text-text-headers dark:text-text-headers-expressive'), "data-animate-fade": true, children: _jsx(EmphasisedText, { children: title }) }), subtitle && (_jsx("p", { className: "text-center type-heading-sm text-text-primary dark:text-text-contrast", "data-animate-fade": true, children: subtitle }))] }), _jsx(Carousel, { minimumSlides: minimumSlides, items: items, onSlideClassName: () => '!w-[75%] sm:!w-[31%]', onSlideRender: ({ isActive, item, accessibilityProps }) => (_jsx(FeatureBrandCard, { ...item, isActive: isActive, viewLabel: viewLabel, accessibilityProps: accessibilityProps })), onSlideImpressions: (items) => dataLayerPush('featuredBrand', {
                    list_interaction: 'Brand Impression',
                    brand_list: 'Featured Stores',
                    brand: {
                        impressions: items.map(({ item, index }) => ({
                            brand_name: item.title,
                            position: index + 1,
                        })),
                    },
                }), hideSlidesUntilHydrated: true, options: {
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    effect: 'coverflow',
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 100,
                        depth: 300,
                        slideShadows: false,
                    },
                    modules: [EffectCoverflow],
                    breakpoints: {
                        700: {
                            coverflowEffect: {
                                rotate: 0,
                                stretch: 100,
                                depth: 200,
                                slideShadows: false,
                            },
                        },
                        1024: {
                            coverflowEffect: {
                                rotate: 0,
                                stretch: 125,
                                depth: 200,
                                slideShadows: false,
                            },
                        },
                        1440: {
                            coverflowEffect: {
                                rotate: 0,
                                stretch: 150,
                                depth: 200,
                                slideShadows: false,
                            },
                        },
                    },
                }, labels: {
                    previousLabel,
                    nextLabel,
                    previousIcon,
                    nextIcon,
                    slideProgressLabel,
                }, onAdditionalDataLayerProps: ({ title }) => ({ carousel_type: 'Featured Stores', brand_name: title }), children: ({ slides, pagination, previousButton, nextButton }) => (_jsxs("div", { className: "flex flex-col gap-1.5 lg:gap-0.75", children: [_jsxs("div", { className: "flex items-center gap-5", "data-animate-fade": true, children: [_jsx("div", { className: "hidden lg:block", children: previousButton }), slides, _jsx("div", { className: "hidden lg:block", children: nextButton })] }), _jsxs("div", { className: "flex items-center justify-between gap-0.5 lg:justify-center", "data-animate-fade": true, children: [_jsx("div", { className: "lg:hidden", children: previousButton }), pagination, _jsx("div", { className: "lg:hidden", children: nextButton })] })] })) }), link?.url && (_jsx("div", { className: "sm:mx-auto", "data-animate-fade": true, children: _jsx(Button, { variant: link.linkDisplay, className: "w-full sm:w-auto", children: ({ icon, ...props }) => (_jsxs("a", { ...props, href: link.url, target: link.target, "aria-label": link.ariaLabel, "data-testid": "featured-stores-cta", onClick: () => dataLayerPush('ctaInteraction', {
                            cta_type: 'Featured Stores',
                            click_text: link.text,
                            click_url: link.url,
                        }), children: [link.text, " ", icon] })) }) }))] }));
};
export default FeaturedStores;
